import { ReactNode } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { MultiSelect } from '../multi-select';
import { FilterIcon } from '../../atoms/icons';

import { useTranslation } from 'react-i18next';

export const FilterButton = ({
  filters,
  setFilters,
  options,
}: {
  filters: string[];
  setFilters: (filters: string[]) => void;
  options: { value: string; label?: ReactNode; permanent?: boolean }[];
}) => {
  const { t } = useTranslation('designSystem');
  const permanentFilters = options
    .filter((option) => option.permanent)
    .map((filter) => filter.value);
  return (
    <div className="flex flex-shrink-0 items-center gap-2">
      <MultiSelect
        options={options}
        setValue={setFilters}
        value={filters}
        label={t('filters')}
        title={t('filters')}
        allowSearch
        showSelectAll
        displaySelected={false}
        trigger={
          <div className="flex h-[40px] divide-x rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 text-gray-600 dark:text-gray-400">
            <button className="flex items-center gap-2 gap-x-3 rounded-l-md px-4 py-1 hover:bg-gray-100 dark:hover:bg-gray-700">
              <span className="mb-[2px] font-medium">{t('filters')}</span>
              <FilterIcon />
            </button>
            {filters.filter((filter) => !permanentFilters.includes(filter))
              .length > 0 && (
              <button
                className="flex flex-grow items-center self-stretch justify-self-stretch rounded-r-md px-2 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-gray-100"
                onClick={(e) => {
                  e.stopPropagation();
                  setFilters(
                    options.filter((o) => o.permanent).map((o) => o.value),
                  );
                }}
              >
                <XMarkIcon className="h-5 w-5" />
              </button>
            )}
          </div>
        }
      />
    </div>
  );
};
